import { render, staticRenderFns } from "./user_xx.vue?vue&type=template&id=90294c2e&scoped=true"
import script from "./user_xx.vue?vue&type=script&lang=js"
export * from "./user_xx.vue?vue&type=script&lang=js"
import style0 from "./user_xx.vue?vue&type=style&index=0&id=90294c2e&prod&scoped=true&lang=less"
import style1 from "./user_xx.vue?vue&type=style&index=1&id=90294c2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90294c2e",
  null
  
)

export default component.exports